// extracted by mini-css-extract-plugin
module.exports = {"checker":"index-module--checker--2KfOu"};